"use client"

import { useEffect, useRef } from "react"
import { useSession } from "next-auth/react"
import { useRouter } from "next/navigation"
import { useLocale } from "next-intl"

/** Refresh the persistent root layout when the authoritative account/preference changes. */
export function LocaleSessionBridge({ actorKey }: { actorKey: string | null }) {
  const { data, status } = useSession()
  const router = useRouter()
  const locale = useLocale()
  const pendingKey = useRef<string | null>(null)
  const user = data?.user
  const currentKey = user ? `${user.user_id}:${user.ui_locale ?? ""}` : ""

  useEffect(() => {
    document.documentElement.lang = locale
  }, [locale])

  useEffect(() => {
    if (status === "loading") return
    // Mounted inside AuthSessionRecovery: a missing session has been confirmed before reaching here.
    if ((actorKey ?? "") === currentKey) { pendingKey.current = null; return }
    if (pendingKey.current === currentKey) return
    pendingKey.current = currentKey
    router.refresh()
  }, [actorKey, currentKey, router, status])
  return null
}
